module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 740
// module chunks = 0